import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  $('a[href*="#"]').on('click', function (e) {
    const url = $(this).attr('href');

    if (url.startsWith('http')) return;

    const currentPath = window.location.pathname;
    const linkPath = url.split('#')[0];

    if (linkPath && linkPath !== '' && linkPath !== currentPath) return;

    e.preventDefault();

    const targetId = '#' + url.split('#')[1];
    const $target = $(targetId);

    $('body').removeClass('menu-open');
    $('.menu-icon').removeClass('is-active');
    $('.top-bar').removeClass('is-active');

    setTimeout(() => {
      if ($target.length) {
        let offset = $('header').outerHeight() || 0;

        const $pageNavItem = $(this).closest('.page-navigation__item');

        if ($pageNavItem.length && window.innerWidth >= 1024) {
          offset += $('.page-navigation__wrapper').outerHeight() - 1 || 0;

          const isFirstItem =
            $pageNavItem.index('.page-navigation__item') === 0;

          if (isFirstItem) {
            offset -= 30;
          }
        }

        $('html, body').animate(
          {
            scrollTop: $target.offset().top - offset,
          },
          600
        );
      }
    }, 50);
  });

  const currentPath = window.location.pathname;

  if (currentPath === '/') {
    $(
      'li.current-menu-item a[href*="#"], li.current_page_item a[href*="#"]'
    ).each(function () {
      const url = $(this).attr('href');

      if (url.startsWith('/#')) {
        const $listItem = $(this).parent('li');

        $listItem.removeClass('current-menu-item current_page_item');
        $(this).removeAttr('aria-current');
      }
    });
  }
});
